export default {
  nift: {
    title: {
      en: 'Get your first month<br class="onlyMobile"/> for less than $7',
    },
    text: {
      // eslint-disable-next-line max-len
      en: 'Use your <strong>$30</strong> Nift gift certificate to score a new designer scent (<strong>{price}</strong>), travel case (<strong>$15.95</strong>), and shipping (<strong>$3.99</strong>) for just <strong>{priceWithDiscount}</strong>. And if you love Scentbird, indulge in new designer scents every month after for just <strong>{price}</strong> per month.',
    },
    note: {
      en: 'You may update your preferences or cancel<br class="onlyMobile"/> at any time.',
    },
  },
  bouqs: {
    title: {
      en: 'Get 60% off and a free case',
    },
    text: {
      en: 'Get your first month for less than <strong>$7</strong> courtesy of Bouqs. Indulge in new designer scents every month after for just <strong>{price}</strong>.',
    },
    note: {
      en: 'Upgrade or cancel at any time.  Deal ends in:',
    },
  },
}
